export default __webpack_public_path__ + "static/media/shimla1.ff4ec2ca.jpg";